import createIcon from '../../createIcon';

/**
 * @component @name MultilineChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNy4xNzQ4OEwyMC41OSA1Ljc2NDg4TDE3Ljc0IDguOTc0ODhDMTUuNjggNi42NTQ4OCAxMi44MyA1LjI1NDg4IDkuNjEgNS4yNTQ4OEM2LjcyIDUuMjU0ODggNC4wNyA2LjQxNDg4IDIgOC4yNTQ4OEwzLjQyIDkuNjc0ODhDNS4xMiA4LjE4NDg4IDcuMjcgNy4yNTQ4OCA5LjYxIDcuMjU0ODhDMTIuMzUgNy4yNTQ4OCAxNC43IDguNTE0ODggMTYuMzggMTAuNDk0OUwxMy41IDEzLjczNDlMOS41IDkuNzM0ODhMMiAxNy4yNDQ5TDMuNSAxOC43NDQ5TDkuNSAxMi43MzQ5TDEzLjUgMTYuNzM0OUwxNy41NSAxMi4xODQ5QzE4LjMgMTMuNTM0OSAxOC44IDE1LjA4NDkgMTguOTkgMTYuNzM0OUgyMUMyMC43OCAxNC40MzQ5IDIwLjA1IDEyLjM0NDkgMTguOTYgMTAuNTk0OUwyMiA3LjE3NDg4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MultilineChart = createIcon('MultilineChart', [
  [
    'path',
    {
      d: 'M22 7.17488L20.59 5.76488L17.74 8.97488C15.68 6.65488 12.83 5.25488 9.61 5.25488C6.72 5.25488 4.07 6.41488 2 8.25488L3.42 9.67488C5.12 8.18488 7.27 7.25488 9.61 7.25488C12.35 7.25488 14.7 8.51488 16.38 10.4949L13.5 13.7349L9.5 9.73488L2 17.2449L3.5 18.7449L9.5 12.7349L13.5 16.7349L17.55 12.1849C18.3 13.5349 18.8 15.0849 18.99 16.7349H21C20.78 14.4349 20.05 12.3449 18.96 10.5949L22 7.17488Z',
      key: '78hnwf',
    },
  ],
]);

export default MultilineChart;
